import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Dropdown from './src/dropdown.vue'
import DropdownItem from './src/dropdown-item.vue'

export const SgDropdown = withInstall(Dropdown, {
  DropdownItem,
})
export default SgDropdown
export const SgDropdownItem = withNoopInstall(DropdownItem)

export * from './src/dropdown'
